export default {
  welcome: 'Velkommen',
  we_miss_you: 'Vi savner dig',
  happy_friday: 'Glædelig fredag',
  lazy_sunday: 'Doven søndag',
  loyalty_program: 'Loyalitetsprogram',
  you_might_also_like: 'Det kunne også interessere dig',
  storefront_promo: 'Butikspromovering',
  welcome_members_club: 'Velkommen til medlemsklubben',
  launch_deal: 'Lanceringstilbud',
};
